import { render, staticRenderFns } from "./ReservationsAndCancellationsStatistics.vue?vue&type=template&id=1b9d9344&scoped=true"
import script from "./ReservationsAndCancellationsStatistics.vue?vue&type=script&lang=js"
export * from "./ReservationsAndCancellationsStatistics.vue?vue&type=script&lang=js"
import style0 from "./ReservationsAndCancellationsStatistics.vue?vue&type=style&index=0&id=1b9d9344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9d9344",
  null
  
)

export default component.exports